<template>
  <div class="chapter">
    <section class="section__introduction section__introduction--01 mt-10">
      <div class="container pl-lg-10 pl-xl-0">
        <div class="row">
          <div class="col-12 text-center">
            <img src="@/assets/images/shiseido_logo_black.svg" class="img-fluid" data-aos="fade-up" data-aos-delay="600">
              <h2 class="color-highlight font-size-56 mt-12" data-aos="fade-up" data-aos-delay="600" v-html="$t('PAGE01_TEXT01')">Welcome to the learning module</h2>
              <h1 class="color-highlight font-size-120 font-bold" data-aos="fade-up" data-aos-delay="600" v-html="$t('PAGE01_TEXT02')">Vital Perfection</h1>
            <h2 class="color-highlight font-size-100 font-bold" data-aos="fade-up" data-aos-delay="600" v-html="$t('PAGE01_TEXT03')">Eye Experts</h2>
          </div>
        </div>
      </div>
    </section>
    <section class="section__introduction section__introduction--02 my-5 d-flex align-items-center justify-content-center">
      <div class="position-absolute purple-line" data-aos="fade-up" data-aos-delay="700"></div>
      <div class="play--btn" v-on:click="openVideoOverlay('s01_intro')" data-aos="fade-up" data-aos-delay="300">
        <img src="@/assets/icons/white/play_button.svg" class="icon__content my-1">
      </div>
    </section>
    <section class="section__introduction section__introduction--03 mb-10">
      <div class="container pl-lg-10 pl-xl-0">

        <div class="row">
          <div class="col-12 col-xl-8 offset-xl-2 text-center">
            <p class="mb-4 span-bold" data-aos="fade-up" data-aos-delay="300" v-html="$t('PAGE01_TEXT04')">
              In this module you will discover <span>2 new eye care experts</span> to target the concerns of mature customers.
              However as the eye area is the number 1 concern for women of all ages
             </p>

            <p class="mb-4" data-aos="fade-up" data-aos-delay="300" v-html="$t('PAGE01_TEXT05')">in just a few minutes you will become an eye care expert enabling you to answer the needs of every customer.</p>
            <p class="mb-4 font-bold" data-aos="fade-up" data-aos-delay="300" v-html="$t('PAGE01_TEXT06')" v-if="user.gift_active == 1 && (user.user.country != 'NL' && user.user.is_douglas != 1)">You also have a chance to test your knowledge and if you
            achieve 80% or more you will be eligible for a gift !
          </p>
            <p class="mb-4 font-bold" data-aos="fade-up" data-aos-delay="300" v-html="$t('PAGE01_TEXT06_NO_GIFT')" v-if="user.gift_active == 0">You also have a chance to test your knowledge and if you
              achieve 80% or more you will be eligible for a gift !
            </p>
            <p data-aos="fade-up" data-aos-delay="300" v-html="$t('PAGE01_TEXT07')">The quiz will not be revealed until you complete the module.</p>
          </div>
          <div class="col-12 text-center mb-10">
            <img src="@/assets/images/01/s03_p01.jpg" class="img-fluid mt-10 mb-6" data-aos="fade-down" data-aos-delay="300">
            <!--<p class="text-uppercase color-highlight font-bold font-size-24 mb-7" data-aos="fade-up" data-aos-delay="200" v-html="$t('PAGE01_TEXT08')" v-if="user.gift_active == 1 && !(user.user.country == 'NL' && user.user.is_douglas == 1)">Completion of the module will earn you 2 seasonal pins</p>
            <img src="@/assets/images/pin_seasonal.png" class="img-fluid mx-2 pin__img" data-aos="fade-up" data-aos-delay="300" v-if="user.gift_active == 1 && !(user.user.country == 'NL' && user.user.is_douglas == 1)">
            <img src="@/assets/images/pin_seasonal.png" class="img-fluid mx-2 pin__img" data-aos="fade-up" data-aos-delay="300" v-if="user.gift_active == 1 && !(user.user.country == 'NL' && user.user.is_douglas == 1)"> -->
          </div>
        </div>

      </div>
    </section>


    <VideoOverlay :lang="user.user.language" ref="videoOverlay" :SelectorClass="'overlay__01'"></VideoOverlay>

    <Footer :kapitel="'02'" />

  </div>
</template>

<script>
import lrsService from "@/services/lrsService";
import Footer from "@/components/partials/Footer";
import VideoOverlay from "@/components/VideoOverlay";
import jQuery from "jquery";
import animationService from "@/services/animationService";
import {gsap, TimelineMax, CSSPlugin, TweenMax} from 'gsap/all'
export default {
  name: "page-010",
  components: {
    Footer, VideoOverlay
  },
  props: {
    kapitel: ""
  },
  data: function () {
    return {
      status: 0,
      tracking: [0,0,0,0],
      moduleStatus: '',
      user: Object
    }
  },
  created() {
    this.$store.watch(
            (state, getters) => getters.moduleStatus,
            (newValue, oldValue) => {
              console.log(`Updating lang from ${oldValue} to ${newValue}`);
              this.moduleStatus = newValue;
              for (let i = 0; i < this.moduleStatus.length; i++) {
                if(this.moduleStatus[i][0] == '01'){
                  this.tracking = [1,1,1,1];
                }
              }
            },
    );
    this.$store.watch(
            (state, getters) => getters.user,
            (newValue, oldValue) => {
              console.log(`Updating lang from ${oldValue} to ${newValue}`);
              if (typeof newValue === 'string' || newValue instanceof String){
                this.user = JSON.parse(newValue)
              }
              this.user = newValue;
              console.log(this.user)
            },
    );
  },
  methods: {
    openVideoOverlay(filename) {
      this.$refs.videoOverlay.$el.classList.add('open');
      let lang = this.$store.getters.lang;
      this.$refs.videoOverlay.playVideo(filename + '.mp4');
      if(this.tracking[3] == 0){
        this.tracking[3] = 1;
        this.incrementScrollIndicator(25);
      }
    },
  },
  beforeMount() {
    this.resetScrollIndicator();
    this.moduleStatus = this.$store.getters.moduleStatus;
    for (let i = 0; i < this.moduleStatus.length; i++) {
      if(this.moduleStatus[i] == this.kapitel){
        this.tracking = [1,1,1,1];
      }
    }
  },
  watch: {
    tracking: function() {
      console.log(this.tracking)
    }
  },
  mounted() {
    let user = this.$store.getters.user;
    if (typeof user === 'string' || user instanceof String){
      user = JSON.parse(user)
    }
    this.user = user;
    console.log(this.user)
    console.log("Test User NL:", !(user.user.country == 'NL' && user.user.is_douglas == 1))
    console.log("Test User NL1:", (user.user.country != 'NL' && user.user.is_douglas != 1))
    this.resetScrollIndicator();
    let _this = this;
      const section1 = _this.$scrollmagic.scene({
        triggerElement: '.section__introduction--01',
        triggerHook: 0,
        reverse:false
      }).on('start', function () {
        if(_this.tracking[0] == 0){
          _this.tracking[0] = 1;
          console.log("Increment Szene 1")
          _this.incrementScrollIndicator(25, "Szene 1");
        }

      })
      const section2 = _this.$scrollmagic.scene({
        triggerElement: '.section__introduction--02',
        triggerHook: 0,
        reverse:false
      }).on('start', function () {
        if(_this.tracking[1] == 0){
          _this.tracking[1] = 1;
          _this.incrementScrollIndicator(25, "Szene 2");
        }
      })
      const section3 = _this.$scrollmagic.scene({
        triggerElement: '.section__introduction--03',
        triggerHook: 0,
        reverse:false
      }).on('start', function () {
        console.log("Calling tracking")
        if(_this.tracking[2] == 0){
          _this.tracking[2] = 1;
          _this.incrementScrollIndicator(25, "Szene 3");
        }
      })
      _this.$scrollmagic.addScene(section1);
      _this.$scrollmagic.addScene(section2);
      _this.$scrollmagic.addScene(section3);

  }
}
</script>

<style scoped>

</style>